import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import * as _ from 'lodash';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';
import { CloneProjectDialogComponent } from '../clone-project-dialog/clone-project-dialog.component';
import { DeleteDialogComponent } from '../delete-dialog/delete-dialog.component';
import { ArchiveProjectDto, CloneProjectDto, ProjectDto, UpdateProjectResponse } from 'projects/shared/src/lib/models/Project';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { ArchiveProjectDialogComponent } from '../archive-project-dialog/archive-project-dialog.component';
import { OAuthServiceService } from 'projects/shared/src/lib/services/o-auth-service.service';

@Component({
  selector: 'admin-projects-button-renderer',
  templateUrl: './admin-projects-button-renderer.component.html',
  styleUrls: ['./admin-projects-button-renderer.component.scss']
})
export class AdminProjectsButtonRendererComponent implements ICellRendererAngularComp {

  params: any;

  icon_edit!: string;
  icon_clone!: string;
  icon_delete!: string;

  routerLinkEditProject!: string;

  projectArchived = false;
  minDateTime = new Date('0001-01-01T00:00:00');

  isUpdProjPossible = true;
  isUpdRunning = false;
  isUpdError = false;
  updErrMsg!: string;
  currentVersion!: string;
  _userRoles:string[] = [];

  constructor(public dialog: MatDialog,
    private oauthService: OAuthServiceService,
    public translate: TranslateService,
    private tenantService: TenantService,
    private notificationService: NotificationService) { }

  refresh(params: ICellRendererParams): boolean {
    const dataParams = params.colDef?.cellRendererParams;
    this.routerLinkEditProject = _.isFunction(dataParams.routerLinkEditProject) ? dataParams.routerLinkEditProject(params) : _.get(params.data, dataParams.routerLinkEditProject);
    return false;
  }

  agInit(params: ICellRendererParams): void {

    this.oauthService.userData.subscribe({
      next: (data) => {
        if (typeof data != undefined && data != null) {
          //self._userRoles = data.role as Array<string>;
          let userRoles = data.role as Array<string>;
          userRoles.forEach((role: string) =>{
            if (role != "MANAGE_USERS" && role != "CREATE_USER" &&  role != "MANAGE_PROJECTS" && role != "CREATE_PROJECT") this._userRoles.push(role);
          })
          //console.log("------> manage-projects self.userRoles (userData): ", self._userRoles)
        }
      }
    });

    this.params = params;
    let proj = params.data as ProjectDto;
    if (proj != undefined) {
      //console.log(">>>>>>>>>>> params = ", proj.display_Name)
      let dateString = proj.archivedWhen;
      //console.log(">>>>>>>>>>> compareDate as strin = ", dateString)
      let compareDate = new Date(dateString.toString());
      //console.log(">>>>>>>>>>> compareDate = ", compareDate)
      this.projectArchived =  new Date(compareDate).getTime() > this.minDateTime.getTime();
    }
    this.icon_edit = this.params.icon_edit || null;
    this.icon_clone = this.params.icon_clone || null;
    this.icon_delete = this.params.icon_delete || null;

    this.routerLinkEditProject = this.params.routerLinkEditProject || null;
    this.refresh(params);
  }

  onClick($event: any) {
    if(this.params.onClick instanceof Function) {
      // put anything into params u want pass into parents component

      const params = {
        event: $event,
        rowData: this.params.node.data
      }
      this.params.onClick(this.params);
    }
  }


  cloneProject() {
    const rowData = [this.params.node.data];
    console.log("-----> cloneProject: rowData", rowData)
    console.log("-----> tenant = ", this.tenantService.currentTenantName)
    const dialogRef = this.dialog.open(CloneProjectDialogComponent, {width: '800px', data: rowData});  
    dialogRef.afterClosed().subscribe({
      next: (result: any) => {

        //wird in CloneProjectDialogComponent gemacht:

        //this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["PROJECTCLONED"]} `);
        // if (result !== undefined) {
          // let cloneProject = new CloneProjectDto();
          // cloneProject.projectId = result.id;
          // cloneProject.name = result.name;
          // cloneProject.url = result.url;
          // cloneProject.inclProjGroupRoles = result.copyGrouproles;
          // cloneProject.inclProjUsers = result.copyUsers;
          // cloneProject.inclContent = result.withContent;
          // console.log("============> cloneProject=", cloneProject)
          // this.notificationService.wait(undefined, "Projekt wird kopiert ....");
          // this.tenantService.cloneProject(this.tenantService.currentTenantName, cloneProject).subscribe({
          //     next:(project) => {
          //       //console.log("=====> cloned project = ",project)
          //       // this.params.data.push(project);
          //       this.params.api.refreshInfiniteCache();
          //       // this.refresh(this.params);
          //       //this.params.api.applyTransaction({ add: [project] });
          //       //this.params.api.redrawRows();
          //       //this.params.onClick(this.params);
          //       this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["PROJECTCLONED"]} `);
          //     },
          //     error: (error: any) => {
          //       //this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["PROJECTCLONEDERROR"]}`);
          //       error.error = (cloneProject.inclContent) ? error.error + "copyProject" : error.error + "createProject";
          //       console.log("=====> cloneProject error = ", error.error)
          //       if (error.error != null) {
          //         this.notificationService.error(`${this.translate.data["ERROR"]}`, `${error.error}`);
          //       }
          //     }
          // })   
          
          this.params.api.refreshInfiniteCache();
        // }
      },
      error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["PROJECTCLONEDERROR"]}`)
    }); 
    //this.params.api.refreshInfiniteCache();
}

  removeProject() {
    // this.notificationService.warning(``, `Projekt löschen noch nicht implementiert`);
    // return;

    const rowData = [this.params.node.data];
    console.log("-----> removeProject: rowData", rowData)
    const dialogRef = this.dialog.open(DeleteDialogComponent, {width: '500px', data: rowData});  
    dialogRef.afterClosed().subscribe({
      next: (result: any) => {
        console.log(result)

        if (result !== undefined) {
          let projectDto = new ProjectDto();
          projectDto.id = result.id;
          projectDto.name = result.name;
          this.tenantService.deleteProject(this.tenantService.currentTenantName,projectDto).subscribe({
            next:(project) => {
              this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["PROJECTREMOVED"]} `);
              this.params.api.refreshInfiniteCache();
      
            },
            error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["PROJECTREMOVEDERROR"]}`)
          });
        }
      },
      error: (error: any) => this.notificationService.error("Error while closing dialog", error)
    });
  }
  archiveProject() {
    // this.notificationService.warning(``, `Projekt löschen noch nicht implementiert`);
    // return;

    const rowData = [this.params.node.data];
    console.log("-----> archiveProject: rowData", rowData)
    const dialogRef = this.dialog.open(ArchiveProjectDialogComponent, {width: '800px', data: rowData});
  
    dialogRef.afterClosed().subscribe({
      next: (result: any) => {
        console.log(result)

        if (result !== undefined) {
                  let archiveProject = new ArchiveProjectDto();
                  archiveProject.projectId = result.id;
                  archiveProject.archiveComment = result.comment;
                  this.tenantService.archiveProject(this.tenantService.currentTenantName, archiveProject).subscribe({
                      next:(success) => {
                        //console.log("=====> cloned project = ",project)
                        if(success){
                          this.params.api.refreshInfiniteCache();
                          this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["PROJECTARCHIVED"]} `);
                        } else
                          this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["PROJECTARCHIVEERROR"]}`)
                      },
                      error: (error: any) => {
                        this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["PROJECTARCHIVEERROR"]}`);
                        console.log("------> error: ", error.error.developerMessage);
                        this.notificationService.info("", error.error.developerMessage.Message);
                      }
                  })        }
      },
      error: (error: any) => this.notificationService.error("Error while closing dialog", error)
    });
  }

  updateProject() {

    const rowData = [this.params.node.data];
    this.tenantService.updateProjectDB(this.tenantService.currentTenantName, rowData[0].id).subscribe({
      next:(response: UpdateProjectResponse) => {
        console.log("-----> updateProjectResponse: ", response)
        
        if (response){
          this.currentVersion = "Version: " + response.currentVersion;
          if (response.isError){
            this.isUpdError = true;
            this.updErrMsg = response.message;
            this.isUpdProjPossible = true;
            this.isUpdRunning = false;
          } else if (response.isRunning){
            this.isUpdRunning = true;
            this.isUpdProjPossible = true;
            this.isUpdError = false;
          } else if(response.isOk){
            this.isUpdProjPossible = false;
            this.isUpdRunning = false;
            this.isUpdError = false;
          }
        } else
          this.notificationService.error(`${this.translate.data["ERROR"]}`, "update DB")
      },
      error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, "update DB")
    })       
  }

}
